import { BitkitAvatar, BitkitLink, useResponsive } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';
import { useEffect, useRef } from 'react';

import { SimplePublicApiApp } from '@/models/App';

type AppListItemProps = SimplePublicApiApp & {
  shouldFocus?: boolean;
};

const AppListItem = ({ slug, title, avatarUrl, owner: { name }, shouldFocus }: AppListItemProps) => {
  const ref = useRef<HTMLDivElement & HTMLAnchorElement>(null);
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (shouldFocus) {
      ref.current?.focus();
    } else {
      ref.current?.blur();
    }
  }, [shouldFocus]);

  return (
    <BitkitLink
      display="flex"
      className="AppListItem"
      href={`/app/${slug}`}
      paddingY="12"
      paddingX={[20, 12]}
      gap={[12, 8]}
      ref={ref}
      alignItems="center"
      _focus={{
        backgroundColor: 'background/hover',
        boxShadow: 'none',
      }}
      _hover={{
        backgroundColor: 'background/hover',
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <BitkitAvatar name={title} src={avatarUrl || ''} size={isMobile ? '48' : '32'} variant="image" />
      <Box flexGrow={1} minWidth="0" overflow="hidden">
        <Text color="text/primary" textStyle={['body/lg/regular', 'sans/size-2/bold']} truncate>
          {title}
        </Text>
        <Text color="text/secondary" textStyle="body/md/regular" truncate>
          {name}
        </Text>
      </Box>
    </BitkitLink>
  );
};

export default AppListItem;
